module.exports = __webpack_public_path__ + "img/sosial1.fd0a1271.svg";